/*
 * CohortSettings Messages
 *
 * This contains all the text for the CohortSettings component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.settings';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Settings',
  },
  productTitle: {
    id: `${scope}.productTitle`,
    defaultMessage: 'Product Settings',
  },
  productDescription: {
    id: `${scope}.productDescription`,
    defaultMessage: 'A PPID is currently required for some learner-facing features.',
  },
  productIdLabel: {
    id: `${scope}.productIdLabel`,
    defaultMessage: 'Pearson Product ID (PPID)',
  },
  productIdPlaceholder: {
    id: `${scope}.productIdPlaceholder`,
    defaultMessage: 'Eg. x-urn:revel:aeb7fa90-b134-11ea-9f4d-a5b246f9138c',
  },
  productModel: {
    id: `${scope}.productModel`,
    defaultMessage: 'Product Model',
  },
  productModelPlaceholder: {
    id: `${scope}.productModelPlaceholder`,
    defaultMessage: 'Select a product model',
  },
  enrollmentTitle: {
    id: `${scope}.enrollmentTitle`,
    defaultMessage: 'Enrollment',
  },
  enrollmentDescription: {
    id: `${scope}.enrollmentDescription`,
    defaultMessage: 'Use this option to manage how students enroll in the class.',
  },
  open: {
    id: `${scope}.open`,
    defaultMessage: 'Open enrollment',
  },
  passport: {
    id: `${scope}.passport`,
    defaultMessage: 'Use Passport to enroll students',
  },
  lti: {
    id: `${scope}.lti`,
    defaultMessage: 'Use LTI to enroll students',
  },
  appearanceTitle: {
    id: `${scope}.appearanceTitle`,
    defaultMessage: 'Class Appearance',
  },
  appearanceDescription: {
    id: `${scope}.appearanceDescription`,
    defaultMessage: 'Use these options to help distinguish different classes from each other',
  },
  bannerImageLabel: {
    id: `${scope}.bannerImageLabel`,
    defaultMessage: 'Banner Image',
  },
  bannerImagePlaceholder: {
    id: `${scope}.bannerImagePlaceholder`,
    defaultMessage: 'Add an optional banner image URL',
  },
  bannerPatternLabel: {
    id: `${scope}.bannerPatternLabel`,
    defaultMessage: 'Banner Pattern',
  },
  bannerPatternPlaceholder: {
    id: `${scope}.bannerPatternPlaceholder`,
    defaultMessage: 'Add an optional banner pattern URL',
  },
  colorLabel: {
    id: `${scope}.colorLabel`,
    defaultMessage: 'Color',
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: 'COPY',
  },
  copyConfirm: {
    id: `${scope}.copyConfirm`,
    defaultMessage: 'COPIED',
  },
  hideKeys: {
    id: `${scope}.hideKeys`,
    defaultMessage: 'Hide keys',
  },
  showKeys: {
    id: `${scope}.showKeys`,
    defaultMessage: 'Show keys',
  },
  sharedKey: {
    id: `${scope}.sharedKey`,
    defaultMessage: 'Shared Key',
  },
  sharedSecret: {
    id: `${scope}.sharedSecret`,
    defaultMessage: 'Shared Secret',
  },
  missingKey: {
    id: `${scope}.missingKey`,
    defaultMessage: 'Missing Key',
  },
  missingSecret: {
    id: `${scope}.missingSecret`,
    defaultMessage: 'Missing Secret',
  },
});
